// NPM MODULES
import React, { useState, useEffect } from 'react';
import {
  Stack,
  InputLabel,
  TextField,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Box,
} from '@mui/material';
import BackButton from '../../../common/BackButton';

// NETWORK
import useDeviceRequest from '../../../../requests/DeviceRequest';

export default function NumberSingle({
  device,
  backButtonClick,
  errorHandler,
}) {
  // Replace state with useState
  const [edits, setEdits] = useState({});
  const { updateNumber } = useDeviceRequest();

  // Replace componentDidMount with useEffect to initialize edits
  useEffect(() => {
    setEdits({
      transferMessage: device.transferMessage || false,
      voiceUrl: device.voiceUrl || '',
      forwardToNo: device.forwardToNo || '',
      statusCallbackUrl: device.statusCallbackUrl || '',
      callForwardingOn: device.callForwardingOn || false,
    });
  }, [device]);

  // Handle form change
  const handleFormChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;

    console.log('Edits is:', { ...edits, [name]: newValue });

    setEdits({
      ...edits,
      [name]: newValue,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const updateData = edits;

      await updateNumber(device.device_id, updateData, errorHandler);
      window.location.href = '/admin/device'; // Force reload - TODO: redo properly
    } catch (e) {
      console.log('Got Device update err:', e);
    }
  };

  // Generate form group for editable fields
  const generateEditFormGroup = (name, label, defaultValue) => {
    return (
      <FormGroup>
        <Stack
          sx={{
            flexDirection: { md: 'row' },
            alignItems: { md: 'center' },
            gap: { md: 2 },
            marginBottom: 2,
          }}
        >
          <InputLabel sx={{ minWidth: 200 }}>{label}</InputLabel>
          <TextField
            name={name}
            type="text"
            defaultValue={defaultValue}
            onChange={handleFormChange}
            fullWidth
            size="small"
          />
        </Stack>
      </FormGroup>
    );
  };

  // Generate form group for non-editable fields
  const generateFormGroup = (label, displayValue) => {
    return (
      <Box sx={{ display: 'flex', gap: 2, marginBottom: 1 }}>
        <Typography fontWeight={700} sx={{ width: 180 }}>
          {label}
        </Typography>
        <Typography>{displayValue}</Typography>
      </Box>
    );
  };

  // Generate Twilio call forward form
  const generateTwilioCallForwardForm = () => {
    return (
      <Box sx={{ maxWidth: 800 }}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={edits.transferMessage}
                name="transferMessage"
                onChange={handleFormChange}
              />
            }
            label="Transfer Message"
          />
        </FormGroup>
        {generateEditFormGroup('voiceUrl', 'Voice URL:', edits.voiceUrl)}
        {generateEditFormGroup(
          'forwardToNo',
          'Forward To Number:',
          edits.forwardToNo
        )}
        {generateEditFormGroup(
          'statusCallbackUrl',
          'Status Callback URL:',
          edits.statusCallbackUrl
        )}
      </Box>
    );
  };

  // Generate form
  const generateForm = () => {
    return (
      <form onSubmit={handleSubmit} onChange={handleFormChange}>
        {generateFormGroup('Device Id:', device.device_id)}
        {generateFormGroup(
          'Dedicated User Id:',
          device.dedicated_user_id || 'N/A'
        )}
        {generateFormGroup(
          'Dedicated User Email:',
          device.dedicated_user_email || 'N/A'
        )}
        {generateFormGroup('Twilio Description Name:', device.device_name)}
        {generateFormGroup('SMS URL:', device.sms_url)}
        {generateFormGroup('SMS Fallback URL:', device.sms_fallback_url)}
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={edits.callForwardingOn}
                name="callForwardingOn"
                onChange={handleFormChange}
              />
            }
            label="Turn Call Forwarding On"
          />
        </FormGroup>

        {edits.callForwardingOn && generateTwilioCallForwardForm()}

        <Button variant="contained" color="secondary" type="submit" disabled>
          Save
        </Button>
      </form>
    );
  };

  // Render
  return (
    <Box>
      <Stack gap={2}>
        <Box>
          <BackButton onClick={backButtonClick} />
        </Box>
        <Typography variant="h4" gutterBottom>
          Manage Number
        </Typography>
      </Stack>

      <Typography variant="h5" gutterBottom>
        {device.reply_tn || 'N/A'}
      </Typography>
      {generateForm()}
    </Box>
  );
}
